import React from 'react';
import Button from '@mui/material/Button';
import CreateIcon from '@mui/icons-material/Create'; // This icon can represent a signature

const SignatureButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <Button
      variant="contained"
      size='large'
      color="primary"
      startIcon={<CreateIcon />}
      onClick={onClick}
    >
      Jetzt Unterschreiben (Sign)
    </Button>
  );
}

export default SignatureButton;
